import React from 'react'
import {Button, Label, Table} from 'reactstrap'
import {AvFeedback, AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation'
import Loader from 'react-loader-spinner'
import {pageHelpers} from '../pages'

import EditIcon from 'react-icons/lib/fa/pencil'
import RemoveIcon from 'react-icons/lib/fa/close'
import AddIcon from 'react-icons/lib/fa/plus'
import DoneIcon from 'react-icons/lib/fa/check'
import SortAscendingIcon from 'react-icons/lib/fa/sort-asc'
import SortDescendingIcon from 'react-icons/lib/fa/sort-desc'

let sortFieldsByProperty = (fields, property, sortDescending = false) => {
    fields = fields.sort(function (a, b) {
        const propA = a[property]
        const propB = b[property]
        return (propA < propB) ? -1 : (propA > propB) ? 1 : 0
    })
    if (sortDescending) {
        fields.reverse()
    }
    return fields
}

export default class FieldListTable extends React.Component {
    constructor(props) {
        super(props)
        const {fields, loading, onAddField, onRemoveField, onUpdateField} = props
        this.onAddField = onAddField
        this.onRemoveField = onRemoveField
        this.onUpdateField = onUpdateField

        this.state = {
            fields,
            loading,
            sortBy: null,
            sortDescending: false,
            editingFieldID: -1,
            fieldNumberWidth: 0,
            fieldNameWidth: 0,
            fieldControlWidth: 0,
        }

        this.setupAddFieldRow = this.setupAddFieldRow.bind(this)
        this.handleSortClick = this.handleSortClick.bind(this)
        this.handleValidUpdateFieldSubmit = this.handleValidUpdateFieldSubmit.bind(this)
        this.handleValidCreateFieldSubmit = this.handleValidCreateFieldSubmit.bind(this)
    }

    componentDidMount() {
        pageHelpers.setupSingleRunAnimationEvents()
        window.addEventListener("resize", this.setupAddFieldRow)
        this.setupAddFieldRow()
    }

    componentWillUnmount() {
        pageHelpers.tearDownSingleRunAnimationEvents()
        window.removeEventListener("resize", this.setupAddFieldRow)
    }

    async componentWillReceiveProps(nextProps) {
        const {fields, loading, onAddField, onRemoveField, onUpdateField} = nextProps
        this.onAddField = onAddField
        this.onRemoveField = onRemoveField
        this.onUpdateField = onUpdateField

        await this.setState({
            fields,
            loading,
        })
        this.setupAddFieldRow()
    }

    handleSortClick(newSortBy) {
        let {sortBy, sortDescending} = this.state
        if (sortBy === newSortBy && sortDescending) {
            sortDescending = false
            sortBy = null
        } else if (sortBy === newSortBy) {
            sortDescending = true
        } else {
            sortDescending = false
            sortBy = newSortBy
        }

        this.setState({sortBy, sortDescending})
    }

    handleValidUpdateFieldSubmit(event, values, fieldID) {
        values['id'] = fieldID
        this.onUpdateField(values)
        this.setState({editingFieldID: -1})
    }

    async handleValidCreateFieldSubmit(event, values) {
        this.setState({editingFieldID: -1})
        await this.onAddField(values)
        this.setupAddFieldRow()
    }

    setupAddFieldRow() {
        let fieldNumElem = document.getElementById("field-number-example")
        let fieldNameElem = document.getElementById("field-name-example")
        let fieldControlElem = document.getElementById("field-control-example")

        if (!fieldNumElem || !fieldNameElem || !fieldControlElem) {
            return
        }

        let fieldNumberWidth = fieldNumElem.offsetWidth - 8
        let fieldNameWidth = fieldNameElem.offsetWidth - 8
        let fieldControlWidth = fieldControlElem.offsetWidth

        this.setState({
            fieldNumberWidth,
            fieldNameWidth,
            fieldControlWidth,
        })
    }

    render() {
        let {fields, loading, editingFieldID, fieldNameWidth, fieldNumberWidth, fieldControlWidth, sortDescending, sortBy} = this.state

        if (sortBy && sortBy.length > 0) {
            fields = sortFieldsByProperty(fields, sortBy, sortDescending)
        }

        return <div className="m-0 p-0 fields-table text-left">
            <Table className="mb-0">
                <thead>
                <tr>
                <th className="text-center field-number-header" onClick={(e) => this.handleSortClick("field_number")}>
                    <small className={(sortBy === "field_number" ? "font-weight-bold sf-blue" : "")}>
                        {sortBy === "field_number" ? (sortDescending ? <SortDescendingIcon className="sort-desc"/> :
                            <SortAscendingIcon className="sort-asc"/>) : null}
                        <span className="d-inline-block d-sm-none">
                            Num
                        </span>
                        <span className="d-none d-sm-inline-block d-md-none">
                            Number
                        </span>
                        <span className="d-none d-md-inline-block">
                            Field Number
                        </span>

                    </small>
                </th>
                <th className="text-center" onClick={(e) => this.handleSortClick("name")}>
                    <small className={(sortBy === "name" ? "font-weight-bold sf-blue" : "")}>
                        {sortBy === "name" ? (sortDescending ? <SortDescendingIcon className="sort-desc"/> :
                            <SortAscendingIcon className="sort-asc"/>) : null}
                        Name
                    </small>
                </th>
                <th>
                </th>
                <th>
                </th>
                </tr>
                </thead>
                {loading ?
                    <tbody>
                    <tr>
                        <td colSpan={20} align="center" valign="middle">
                            <Loader type="TailSpin" color="orange" width={60} height={60}/>
                        </td>
                    </tr>
                    <tr className="invisible">
                        <td id="field-number-example">
                            <small className="font-weight-bold text-muted">
                                #123456
                            </small>
                        </td>
                        <td colSpan={2} id="field-name-example">
                            No Name
                        </td>
                        <td id="field-control-example" className="field-table-control">
                            <Button color="danger">
                                <RemoveIcon/>
                            </Button>
                        </td>
                    </tr>
                    </tbody> :
                    <tbody>
                    {fields.map((f) =>
                        (f.id === editingFieldID ?
                            <tr key={`${f.id}-${f.field_number}-${f.name}`}>
                                <td colSpan={4}>
                                    <AvForm className="row"
                                            onValidSubmit={(e, v) => this.handleValidUpdateFieldSubmit(e, v, f.id)}
                                            onInvalidSubmit={pageHelpers.handleInvalidFormSubmit} model={f}>
                                        <AvGroup className="d-inline-block pl-1 pl-md-3"
                                                 style={{width: fieldNumberWidth}}>
                                            <AvInput name="field_number" type="number" min={1} max={65000}/>
                                            <AvFeedback>Must be between 0 and 65000</AvFeedback>
                                        </AvGroup>
                                        <AvGroup className="d-inline-block pl-1 pl-3" style={{width: fieldNameWidth}}>
                                            <AvInput name="name" type="text" maxLength={140}/>
                                        </AvGroup>
                                        <AvGroup className="d-inline-block pr-1 pl-1 pl-md-3 pr-md-3"
                                                 style={{width: fieldControlWidth}}>
                                            <Button color="success">
                                                <DoneIcon/>
                                            </Button>
                                        </AvGroup>
                                    </AvForm>
                                </td>
                            </tr> :
                            <tr key={`${f.id}-${f.field_number}-${f.name}`}>
                                <td>
                                    <small className="font-weight-bold text-muted">
                                        #{f.field_number}
                                    </small>
                                </td>
                                <td className={(f.name && f.name.length ? null : "text-muted")}>
                                    {(f.name || "No Name")}
                                </td>
                                <td className="field-table-control">
                                    <Button color="warning"
                                            className="mr-1"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                this.setState({editingFieldID: f.id})
                                            }}>
                                        <EditIcon/>
                                    </Button>
                                </td>
                                <td className="field-table-control">
                                    <Button color="danger"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                this.onRemoveField(f.id)
                                            }}>
                                        <RemoveIcon/>
                                    </Button>
                                </td>
                            </tr>)
                    )}
                    <tr className="invisible">
                        <td id="field-number-example">
                            <small className="font-weight-bold text-muted">
                                #123456
                            </small>
                        </td>
                        <td id="field-name-example">
                            No Name
                        </td>
                        <td id="field-control-example" className="field-table-control">
                            <Button color="danger">
                                <RemoveIcon/>
                            </Button>
                        </td>
                        <td className="field-table-control">
                            <Button color="danger">
                                <RemoveIcon/>
                            </Button>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={4} className="bg-muted-sf-orange border-top-light-sf-orange pl-0 pr-0">
                            <AvForm className="row col-12 m-0 p-0" onValidSubmit={this.handleValidCreateFieldSubmit}
                                    onInvalidSubmit={pageHelpers.handleInvalidFormSubmit} model={{}}>
                                <Label className="text-left small col-12">Add New Field</Label>
                                <AvGroup className="d-inline-block pl-1 pl-md-3" style={{width: fieldNumberWidth}}>
                                    <AvInput placeholder="Number" name="field_number" type="number" min={1}
                                             max={65000} required/>
                                    <AvFeedback>Number is required (0 - 65000)</AvFeedback>
                                </AvGroup>
                                <AvGroup className="d-inline-block pl-1 pl-3" style={{width: fieldNameWidth+fieldControlWidth}}>
                                    <AvInput placeholder="Name" name="name" type="text" maxLength={140}/>
                                    <AvFeedback>Name cannot be longer than 140 characters</AvFeedback>
                                </AvGroup>
                                <AvGroup className="d-inline-block pr-1 pl-1 pl-md-3 pr-md-3"
                                         style={{width: fieldControlWidth}}>
                                    <Button className="bg-light-sf-blue border-sf-blue">
                                        <AddIcon/>
                                    </Button>
                                </AvGroup>
                            </AvForm>
                        </td>
                    </tr>
                    </tbody>}
            </Table>
        </div>
    }
}




// WEBPACK FOOTER //
// ./src/components/ui/FieldListTable.js